export default "/images/vendor/flag-icon-css/flags/1x1/bf.svg?bb616c9ec60cde6806bbc1c62b4e2a6d";